import React from "react";
import classnames from "classnames";
import { NO_DATA_FOUND } from "../../../../../constants";
import { getUserData } from "../../../../../utils/localStorage";

import RadioButton from "../../../../../components/formElements/radio-button/RadioButton";
import defaultPic from "../../../../../assets/onboarding/default_pic.svg";

import "./index.css";

const ParticipantsList = ({
  physicians,
  futureAppointment,
  selectedId,
  setSelectedId,
}) => {
  const fetchedPhysicians = physicians;

  return (
    <>
      {fetchedPhysicians?.length === 0 ? (
        <p className="content-center m-auto not-found-image">
          <img
            src={NO_DATA_FOUND}
            width={366}
            height={300}
            alt="requests-not-found"
            className={classnames(futureAppointment ? "" : "m-40")}
          />
        </p>
      ) : (
        <div className=" note-templates w-100 px-3 mt-2 pb-5">
          <p
            className={classnames(
              futureAppointment ? "ml-2" : "choose-participant"
            )}
          >
            Choose from the list to add{" "}
          </p>
          <div
            className={classnames(
              futureAppointment
                ? "futureAppointment-participants-list"
                : "participants-list"
            )}
          >
            {fetchedPhysicians.map(phy => {
              return (
                <>
                  {phy.id !== getUserData()?.id && (
                    <div className="pb-4">
                      {" "}
                      <RadioButton
                        checked={selectedId === phy?.id}
                        label={
                          <div className="d-inline-block m-0 p-0">
                            <div
                              className="d-inline-block m-0 p-0"
                              style={{
                                verticalAlign: "middle",
                              }}
                            >
                              <img
                                src={phy?.image || defaultPic}
                                width={40}
                                height={40}
                                className="profile-image-secondary mr-2 d-block"
                                alt={phy?.id}
                              />
                            </div>
                            <div className="d-inline-block participant-name">
                              <span>
                                {phy.first_name} {phy.last_name}
                              </span>
                              <br />
                              <span
                                className="position-absolute"
                                style={{
                                  fontSize: 14,
                                  width: futureAppointment ? 250 : 180,
                                }}
                              >
                                <span
                                  className="position-absolute specialities-container"
                                  style={{
                                    width: futureAppointment ? 220 : 150,
                                  }}
                                >
                                  {phy?.speciality?.join(", ")}
                                </span>
                                <span
                                  className="position-absolute"
                                  style={{
                                    right: -20,
                                  }}
                                >
                                  $ {phy?.practice_details?.fees}
                                </span>
                              </span>
                            </div>
                          </div>
                        }
                        onChange={() => setSelectedId(phy?.id)}
                      />
                    </div>
                  )}
                </>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default ParticipantsList;
